import { Button } from "antd";
import { CurrencyFormat, formatDate } from "../../../../components/helpers";

export const convertNonCashPaymentList = (data, handleOpenPreview) => {
  let converted = [];

  if (!data) return [];
  data.forEach((loan, index) => {
    converted.push({
      key: index + 1,
      transferId: loan?.id,
      gadaiID: loan?.gadai_id,
      dateTime: formatDate(loan.created_at) || "-",
      sbg: loan.sbg_code || "-",
      receiptNumber: loan.receipt_number || "-",
      customerName: loan.ktp_name || "-",
      amount: `Rp ${CurrencyFormat(loan.gadai_transfer.amount) || 0}`,
      accountName: loan.gadai_transfer.office_account_name || "-",
      bankOrAccountNumber:
        `${loan.gadai_transfer.office_bank_name} / ${loan.gadai_transfer.office_account_number}` ||
        "-",
      transferProof: (
        <Button
          onClick={handleOpenPreview(`gadai-transfer/${loan?.gadai_transfer?.id}/proof-picture`)}
          type="link"
          style={{color:'#2C465C'}}
        >
          Lihat File
        </Button>
      ),
    });
  });
  return converted;
};
